/*
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-08-20 17:57:04
 * @LastEditors: wl
 * @LastEditTime: 2020-08-20 20:40:16
 */
import axios from '../axios'
// 预警类型  strategy_type_list
export const handleQuery = (data) => {
    return axios({
        url: '/admin/service/sys_placard_list',
        method: 'post',
        data
    })
}
//
export const handleSave = (data) => {
    return axios({
        url: '/admin/service/sys_placard_save',
        method: 'post',
        data
    })
}

export const batchDeleteType = (data) => {
    return axios({
        url: '/admin/service/sys_placard_del',
        method: 'post',
        data
    })
}
//投票新增与修改
export const weixin_vote_add = (data) => {
    return axios({
        url: '/admin/service/weixin_vote_add',
        method: 'post',
        data
    })
}
//投票列表
export const weixin_vote_list = (data) => {
    return axios({
        url: '/admin/service/weixin_vote_list',
        method: 'post',
        data
    })
}
//投票答案选项列表
export const weixin_answer_list = (data) => {
    return axios({
        url: '/admin/service/weixin_answer_list',
        method: 'post',
        data
    })
}
//投票答案选项增删改
export const weixin_answer_operate = (data) => {
    return axios({
        url: '/admin/service/weixin_answer_operate',
        method: 'post',
        data
    })
}

//通知增删改
export const add_notice = (data) => {
    return axios({
        url: '/admin/service/add_notice',
        method: 'post',
        data
    })
}
//通知列表
export const list_notice = (data) => {
    return axios({
        url: '/admin/service/list_notice',
        method: 'post',
        data
    })
}
//党员风采
export const party_style_list = (data) => {
    return axios({
        url: '/admin/service/party_style_list',
        method: 'post',
        data
    })
}
//党建先锋列表
export const party_building_list = (data) => {
    return axios({
        url: '/admin/service/party_building_list',
        method: 'post',
        data
    })
}
//添加党建先锋
export const party_building_saveAndUpdate = (data) => {
    return axios({
        url: '/admin/service/party_building_saveAndUpdate',
        method: 'post',
        data
    })
}
//删除党建先锋
export const party_building_remove = (data) => {
    return axios({
        url: '/admin/service/party_building_remove',
        method: 'post',
        data
    })
}
//删除网格管理
export const DelDataa = (data) => {
    return axios({
        url: '/admin/service/DelData',
        method: 'post',
        data
    })
}
//党建要闻列表
export const party_important_news = (data) => {
    return axios({
        url: '/admin/service/party_important_news',
        method: 'post',
        data
    })
}
//党建要闻新增删除修改
export const party_important_news_update = (data) => {
    return axios({
        url: '/admin/service/party_important_news_update',
        method: 'post',
        data
    })
}
//添加志愿者
export const volunteer_saveAndUpdate = (data) => {
    return axios({
        url: '/admin/service/volunteer_saveAndUpdate',
        method: 'post',
        data
    })
}
//审核志愿者
export const sys_activity_volunteer_edit = (data) => {
    return axios({
        url: '/admin/service/sys_activity_volunteer_edit',
        method: 'post',
        data
    })
}
//添加自动回复
export const auto_reply_set = (data) => {
    return axios({
        url: '/admin/service/auto_reply_set',
        method: 'post',
        data
    })
}
//添加自动回复
export const auto_reply_list = (data) => {
    return axios({
        url: '/admin/service/auto_reply_list',
        method: 'post',
        data
    })
}
//删除自动回复
export const auto_reply_del = (data) => {
    return axios({
        url: '/admin/service/auto_reply_del',
        method: 'post',
        data
    })
}

//活动审核
export const sys_activity_reservation_edit = (data) => {
    return axios({
        url: '/admin/service/sys_activity_reservation_edit',
        method: 'post',
        data
    })
}
//查询志愿者
export const sys_audit_list = (data) => {
    return axios({
        url: '/admin/service/sys_audit_list',
        method: 'post',
        data
    })
}
//查询志愿者
export const volunteer_list = (data) => {
    return axios({
        url: '/admin/service/volunteer_list',
        method: 'post',
        data
    })
}
//查询人脸设备状态
export const device_login_log = (data) => {
    return axios({
        url: '/admin/service/device_login_log',
        method: 'post',
        data
    })
}

//获取GSM人体传感器实时数据
export const get_gsm_data = (data) => {
    return axios({
        url: '/admin/service/get_gsm_data',
        method: 'post',
        data
    })
}
//绑定与解绑gsm
export const DelData = (data) => {
    return axios({
        url: '/admin/service/gsm_bundOrUnbund',
        method: 'post',
        data
    })
}
//gsm列表
export const gsm_device_list = (data) => {
    return axios({
        url: '/admin/service/gsm_device_list',
        method: 'post',

        data
    })
}
//网格列表
export const grid_info_get = (data) => {
    return axios({
        url: '/admin/service/grid_info_get',
        method: 'post',

        data
    })
}
// 导出
export const export_xq = (cid) => {
    return axios({
        url: '/person_export/'+cid,
        responseType: "blob",
        method: 'get',
    })
}
// 养老设备实时状态
export const gsm_getData = (data) => {
    return axios({
        url: '/admin/service/gsm_getData',
        method: 'post',
        data
    })
}
export const gsm_getData_history = (data) => {
    return axios({
        url: '/admin/service/gsm_getData_history',
        method: 'post',
        data
    })
}
// 获取物联网环境监测的列表
export const msg_temperatureLog_list = (data) => {
    return axios({
        url: '/admin/service/msg_temperatureLog_list',
        method: 'post',
        data
    })
}
// 获取物联网烟雾报警器的列表
export const alarm_smokeSensation_getData = (data) => {
    return axios({
        url: '/admin/service/alarm_smokeSensation_getData',
        method: 'post',
        data
    })
}
// 获取AI0T的列表
export const msg_temperature_list = (data) => {
    return axios({
        url: '/admin/service/msg_temperature_list',
        method: 'post',
        data
    })
}
//绑定AI0T的列表数据
export const msg_temperature_binding = (data) => {
    return axios({
        url: '/admin/service/msg_temperature_binding',
        method: 'post',
        data
    })
}
//解绑AI0T的列表数据
export const msg_temperature_unbundling = (data) => {
    return axios({
        url: '/admin/service/msg_temperature_unbundling',
        method: 'post',
        data
    })
}
//投票详情，阅读量加一
export const weixin_vote_one = (data) => {
    return axios({
        url: '/admin/service/weixin_vote_one',
        method: 'post',
        data
    })
}
//党员事迹增改
export const party_member_story_addup = (data) => {
    return axios({
        url: '/admin/service/party_member_story_addup',
        method: 'post',
        data
    })
}
//党员事迹列表
export const party_member_story_list = (data) => {
    return axios({
        url: '/admin/service/party_member_story_list',
        method: 'post',
        data
    })
}
//党员事迹删除
export const party_member_story_remove = (data) => {
    return axios({
        url: '/admin/service/party_member_story_remove',
        method: 'post',
        data
    })
}
//安全宣传增加
export const safe_propagate_add = (data) => {
    return axios({
        url: '/admin/service/safe_propagate_add',
        method: 'post',
        data
    })
}
//安全宣传列表
export const safe_propagate_list = (data) => {
    return axios({
        url: '/admin/service/safe_propagate_list',
        method: 'post',
        data
    })
}
//社区应急列表
export const community_emergency_list = (data) => {
    return axios({
        url: '/admin/service/community_emergency_list',
        method: 'post',
        data
    })
}
//社区应急新增
export const community_emergency_add = (data) => {
    return axios({
        url: '/admin/service/community_emergency_add',
        method: 'post',
        data
    })
}
//网格信息新增
export const grid_person_add = (data) => {
    return axios({
        url: '/admin/service/sys_gridPerson_add ',
        method: 'post',
        data
    })
}
//视频资源（非监控）上传
export const video_upload = (data) => {
    return axios({
        url: '/video_upload',
        method: 'post',
        data
    })
}
//视频资源（非监控）新增修改删除
export const video_update = (data) => {
    return axios({
        url: '/admin/service/video_update',
        method: 'post',
        data
    })
}
//视频资源（非监控）列表
export const nolive_video_list = (data) => {
    return axios({
        url: '/admin/service/nolive_video_list',
        method: 'post',
        data
    })
}
//视频资源（非监控）删除文件接口
export const sys_video_del = (data) => {
    return axios({
        url: '/admin/service/sys_video_del',
        method: 'post',
        data
    })
}
//政策宣传新增
export const sys_policy_add = (data) => {
    return axios({
        url: '/admin/service/sys_policy_add',
        method: 'post',
        data
    })
}
//政策宣传列表
export const sys_policy_list = (data) => {
    return axios({
        url: '/admin/service/sys_policy_list',
        method: 'post',
        data
    })
}
//人脸设备新增
export const sys_facedevice_save = (data) => {
    return axios({
        url: '/admin/service/sys_facedevice_save',
        method: 'post',
        data
    })
}
// 党建流转新增
export const sys_theCirculation_add = (data) => {
    return axios({
        url: '/admin/service/sys_theCirculation_add',
        method: 'post',
        data
    })
}
// 党建流转列表
export const sys_theCirculation_list = (data) => {
    return axios({
        url: '/admin/service/sys_theCirculation_list',
        method: 'post',
        data
    })
}
//活动管理新增
export const sys_activity_add = (data) => {
    return axios({
        url: '/admin/service/sys_activity_add',
        method: 'post',
        data
    })
}
//活动管理查询
export const sys_activity_list = (data) => {
    return axios({
        url: '/admin/service/sys_activity_list',
        method: 'post',
        data
    })
}
//活动管理删除
export const sys_activity_delete = (data) => {
    return axios({
        url: '/admin/service/sys_activity_delete',
        method: 'post',
        data
    })
}

//工作管理新增
export const sys_work_add = (data) => {
    return axios({
        url: '/admin/service/sys_work_add',
        method: 'post',
        data
    })
}
//工作管理查询
export const sys_work_list = (data) => {
    return axios({
        url: '/admin/service/sys_work_list',
        method: 'post',
        data
    })
}
//工作管理删除
export const sys_work_delete = (data) => {
    return axios({
        url: '/admin/service/sys_work_delete',
        method: 'post',
        data
    })
}
//关怀任务
export const make_care_mission = (data) => {
    return axios({
        url: '/admin/service/make_care_mission',
        method: 'post',
        data
    })
}
//场地预约
export const sys_field_add = (data) => {
    return axios({
        url: '/admin/service/sys_field_add',
        method: 'post',
        data
    })
}
//厨房配送
export const sys_food_add  = (data) => {
    return axios({
        url: '/admin/service/sys_food_add ',
        method: 'post',
        data
    })
}
//厨房配送列表
export const sys_food_list   = (data) => {
    return axios({
        url: '/admin/service/sys_food_list  ',
        method: 'post',
        data
    })
}
//厨房预约记录
export const sys_food_order_list = (data) => {
    return axios({
        url: '/admin/service/sys_food_order_list',
        method: 'post',
        data
    })
}
//厨房预约审核
export const sys_food_audit = (data) => {
    return axios({
        url: '/admin/service/sys_food_audit',
        method: 'post',
        data
    })
}

//关怀任务查询
export const care_mission_list = (data) => {
    return axios({
        url: '/admin/service/care_mission_list',
        method: 'post',
        data
    })
}
//场地预约查询
export const sys_field_list = (data) => {
    return axios({
        url: '/admin/service/sys_field_list',
        method: 'post',
        data
    })
}
//场地预约查询
export const business_field = (data) => {
    return axios({
        url: '/admin/service/business_field',
        method: 'post',
        data
    })
}

//垃圾分类
export const rubbish_make = (data) => {
    return axios({
        url: '/admin/service/rubbish_make',
        method: 'post',
        data
    })
}
//垃圾分类查询
export const rubbish_list = (data) => {
    return axios({
        url: '/admin/service/rubbish_list',
        method: 'post',
        data
    })
}
//部门新增
export const party_depart_add = (data) => {
    return axios({
        url: '/admin/service/party_depart_add',
        method: 'post',
        data
    })
}
//部门列表
export const party_depart_list = (data) => {
    return axios({
        url: '/admin/service/party_depart_list',
        method: 'post',
        data
    })
}
// 根据GID查询department
export const party_find_byGID = (data) => {
    return axios({
        url: '/admin/service/party_find_byGID',
        method: 'post',
        data
    })
}
//组织列表
export const sys_party_organize = (data) => {
    return axios({
        url: '/admin/service/sys_party_organize',
        method: 'post',
        data
    })
}
//小区排名列表
export const sys_comment_list = (data) => {
    return axios({
        url: '/admin/service/sys_comment_list',
        method: 'post',
        data
    })
}
//商家入驻列表
export const wx_business_list = (data) => {
    return axios({
        url: '/admin/service/wx_business_list',
        method: 'post',
        data
    })
}
//商家入驻修改
export const wx_business_entry = (data) => {
    return axios({
        url: '/admin/service/wx_business_entry',
        method: 'post',
        data
    })
}
//志愿者删除
export const volunteer_remove = (data) => {
    return axios({
        url: '/admin/service/volunteer_remove',
        method: 'post',
        data
    })
}
// 志愿者审核
export const volunteer_audit = (data) => {

    return axios({
        url: '/admin/service/volunteer_audit',
        method: 'post',
        data
    })

}

//短信预警新增删除
export const earlyWarning_configuration = (data) => {
    return axios({
        url: '/admin/service/earlyWarning_configuration',
        method: 'post',
        data
    })
}
//短信预警列表
export const earlyWarning_list = (data) => {
    return axios({
        url: '/admin/service/earlyWarning_list',
        method: 'post',
        data
    })
}
//新小区评分
export const community_comment = (data) => {
    return axios({
        url: '/admin/service/community_comment',
        method: 'post',
        data
    })
}
//新小区评分排序列表
export const community_comment_list = (data) => {
    return axios({
        url: '/admin/service/community_comment_list',
        method: 'post',
        data
    })
}
//党员之声列表
export const party_member_sound_list = (data) => {
    return axios({
        url: '/admin/service/party_member_sound_list',
        method: 'post',
        data
    })
}
//党员之声修改
export const party_member_sound = (data) => {
    return axios({
        url: '/admin/service/party_member_sound',
        method: 'post',
        data
    })
}

//党员之声阅读处理
export const party_member_sound_reply = (data) => {
    return axios({
        url: '/admin/service/party_member_sound_reply',
        method: 'post',
        data
    })
}
//小程序在线办理服务列表
export const wx_online_list = (data) => {
    return axios({
        url: '/admin/service/wx_online_list',
        method: 'post',
        data
    })
}
//厨房
export const sys_auditlist = (data) => {
    return axios({
        url: '/admin/service/sys_audit_list',
        method: 'post',
        data
    })
}
//小程序在线办理服务修改
export const wx_online_server_make = (data) => {
    return axios({
        url: '/admin/service/wx_online_server_make',
        method: 'post',
        data
    })
}
//小程序在线办理服务修改
export const sys_reservation_audit = (data) => {
    return axios({
        url: '/admin/service/sys_reservation_audit',
        method: 'post',
        data
    })
}
//移除每一个(统一删除)
export const remove_every = (data) => {
    return axios({
        url: '/admin/service/remove_every',
        method: 'post',
        data
    })
}
//删除网格
export const sys_grid_remove = (data) => {
    return axios({
        url: '/admin/service/sys_grid_remove',
        method: 'post',
        data
    })
}
//新增图片
export const addPicture = (data) => {
    return axios({
        url: '/admin/service/addPicture',
        method: 'post',
        data
    })
}
//图片列表
export const pictureList = (data) => {
    return axios({
        url: '/admin/service/pictureList',
        method: 'post',
        data
    })
}
//法律援助新增
export const lawUpdate = (data) => {
    return axios({
        url: '/admin/service/lawUpdate',
        method: 'post',
        data
    })
}
//学校列表新增
export const student_add   = (data) => {
    return axios({
        url: '/admin/service/student_add  ',
        method: 'post',
        data
    })
}
//部门联动新增
export const sys_departmentContact_add = (data) => {
    return axios({
        url: '/admin/service/sys_departmentContact_add',
        method: 'post',
        data
    })
}
//法律援助列表
export const student_list = (data) => {
    return axios({
        url: '/admin/service/student_list',
        method: 'post',
        data
    })
}
//学校数据列表
export const lawsList = (data) => {
    return axios({
        url: '/admin/service/lawsList',
        method: 'post',
        data
    })
}
//积分列表
export const tmp_peroson_point = (data) => {
    return axios({
        url: '/admin/service/tmp_peroson_point',
        method: 'post',
        data
    })
}
//社区联动列表
export const sys_departmentContact_list = (data) => {
    return axios({
        url: '/admin/service/sys_departmentContact_list',
        method: 'post',
        data
    })
}
//假日预约列表
export const holidayList = (data) => {
    return axios({
        url: '/admin/service/holidayList',
        method: 'post',
        data
    })
}


//各类数据列表
export const allKindOf_list = (data) => {
    return axios({
        url: '/admin/service/allKindOf_list',
        method: 'post',
        data
    })
}
// 心愿列表
export const sys_wish_list = (data) => {
    return axios({
        url: '/admin/service/sys_wish_list',
        method: 'post',
        data
    })
}
//假日预约列表
export const holidayUpdate = (data) => {
    return axios({
        url: '/admin/service/holidayUpdate',
        method: 'post',
        data
    })
}
//更新数据是否已读
export const updateRead = (data) => {
    return axios({
        url: '/admin/service/updateRead',
        method: 'post',
        data
    })
}
//更新数据是否已读
export const updateContentArray = (data) => {
    return axios({
        url: '/admin/service/updateContentArray',
        method: 'post',
        data
    })
}
//各类数据添加
export const sys_addUpdate = (data) => {
    return axios({
        url: '/admin/service/sys_addUpdate',
        method: 'post',
        data
    })
}

//心愿墙
export const sys_wish_examine = (data) => {
    return axios({
        url: '/admin/service/sys_wish_examine',
        method: 'post',
        data
    })
}
// 添加心愿
// sys_wish_add
export const sys_wish_add = (data) => {
    return axios({
        url: '/admin/service/sys_wish_add',
        method: 'post',
        data
    })
}
//防疫填报
export const sys_people_get = (data) => {
    return axios({
        url: '/admin/service/getPeopleBackInfoList',
        method: 'post',
        data
    })
}
//

export const sys_device_log = (data) => {
    return axios({
        url: '/admin/service/sys_device_log',
        method: 'post',
        data
    })
}

// 从业推送标记已读
export const sys_service_mark = (data) => {
    return axios({
        url: '/admin/service/sys_service_mark',
        method: 'post',
        data
    })
}
// 评价列表

export const evaluate_list = (data) => {
    return axios({
        url: '/admin/service/activity_evaluate_list',
        method: 'post',
        data
    })
}
//云曜设备
export const sys_facedevice_list = (data) => {
    return axios({
        url: '/admin/service/sys_facedevice_list',
        method: 'post',
        data
    })
}
//云曜解绑
export const sys_facedevice_delete = (data) => {
    return axios({
        url: '/admin/service/sys_facedevice_delete',
        method: 'post',
        data
    })
}
//云曜查看

export const sys_facedevice_onoffline = (data) => {
    return axios({
        url: '/admin/service/sys_facedevice_onoffline',
        method: 'post',
        data
    })
}

//志愿者积分
export const volunteer_points_add = (data) => {
    return axios({
        url: '/admin/service/volunteer_points_add',
        method: 'post',
        data
    })
}

export const volunteer_points_list = (data) => {
    return axios({
        url: '/admin/service/volunteer_points_list',
        method: 'post',
        data
    })
}
//巡访添加
export const sys_patrol_add = (data) => {
    return axios({
        url: '/admin/service/sys_patrol_add',
        method: 'post',
        data
    })
}
//巡访列表
export const sys_patrol_list = (data) => {
    return axios({
        url: '/admin/service/sys_patrol_list',
        method: 'post',
        data
    })
}
//巡访删除
export const sys_patrol_del = (data) => {
    return axios({
        url: '/admin/service/sys_patrol_del',
        method: 'post',
        data
    })
}
//事件管理列表
export const aiot_event_list = (data) => {
    return axios({
        url: '/admin/service/aiot_event_list',
        method: 'post',
        data
    })
}
//事件处理
export const aiot_event_handle = (data) => {
    return axios({
        url: '/admin/service/aiot_event_handle',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/wxNotic.js